export class Application {
  distribID: string;
  appEnabled: boolean;
  adminEnabled: boolean = false;
  children: Application[];
  isTopLevel: boolean = true;
  isInDropdown: boolean;
  isAdministrationOnly: boolean = false;

  constructor(distribID: string, isEnabled: boolean = false) {
    this.distribID = distribID;
    this.appEnabled = isEnabled;
  }
}
